var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-block"},[_c('div',{staticClass:"ui-block-title"},[_c('div',{staticClass:"h6 title"},[_vm._v("\n      Showing "+_vm._s(_vm.count)+" of "+_vm._s(_vm.total)+" results for:\n      “"),_c('span',{staticClass:"c-primary"},[_vm._v(_vm._s(_vm.categories))]),_vm._v("”\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }